import JsUtil from "./func/util";
import {module} from './func/restore.js';

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        home:true,
        event:true,
        sns:true,
        theme:'black'
    },
    caution:{
        template:
        `<ol>
            <li>제재 계정 및 테스트서버는 본 이벤트에 참여할 수 없습니다.</li>
            <li>아이템 복구 시 아이템(각인) 및 TJ / 시그니처 1~4차 쿠폰으로 복구 받은 아이템은 제외됩니다.</li>
            <li>선택한 아이템은 다음 정기점검 시 지급됩니다.</li>
            <li>아이템이 확정되면 다른 아이템 선택이 불가능합니다.</li>
            <li>아이템 복구로 지급되는 아이템은 각인(거래불가) 상태로 지급됩니다.</li>
            <li>아이템의 사용 가능 클래스 확인 후 아이템 선택 부탁드립니다.</li>
            <li>캐릭터가 삭제되거나 서버 이전으로 지급 받는 캐릭터가 이전한 경우 아이템 복구가 불가능합니다.</li>
            <li>각인 아이템은 룸티스/스냅퍼 +1 강화권 사용이 불가합니다.</li>
            <li>복구 아이템 리스트는 공지사항을 참고 부탁드립니다. <a href="https://lineage.plaync.com/board/notice/view?articleId=62033fc2976a9518e3d1455e&categoryId=0&viewMode=list&size=20">[공지사항 바로가기]</a></li>
        </ol>`
    }
});

/* 각종 유틸 메소드를 가진 util 인스턴스. */
window.jsUtil = new JsUtil();


